/** Paths always reachable while the proxy is disconnected (configure / connect). */
export const PROXY_EXEMPT_PATHS = ['/proxy-settings'] as const;

/** Non-execution app areas: show the disconnected banner but do not auto-redirect. */
export const PROXY_OPTIONAL_PATHS = [
  '/',
  '/dashboard',
  '/projects',
  '/environments',
  '/env-variables',
  '/functions',
  '/help',
  '/profile',
  '/history',
  '/trash',
  '/manage-account',
  '/pricing',
  '/payment',
] as const;

/** Routes that send HTTP traffic through the local proxy agent. */
export const PROXY_REQUIRED_PATH_PREFIXES = [
  '/collections',
  '/test-plans',
  '/test-cycles',
  '/swagger',
  '/raw-json-table',
  '/ai-agent',
  '/console',
] as const;

export const PROXY_DISCONNECTED_MESSAGE =
  'CRUD Expert desktop agent is not connected. Install and start it on http://localhost:9000 to continue.';

function normalizePath(pathname: string): string {
  if (!pathname) return '/';
  const base = pathname.split('?')[0].split('#')[0];
  if (base.length > 1 && base.endsWith('/')) return base.slice(0, -1);
  return base || '/';
}

export function isProxyExemptPath(pathname: string): boolean {
  const path = normalizePath(pathname);
  return PROXY_EXEMPT_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}

export function isProxyOptionalPath(pathname: string): boolean {
  const path = normalizePath(pathname);
  if (isProxyExemptPath(path)) return true;
  return PROXY_OPTIONAL_PATHS.some((p) => {
    if (p === '/') return path === '/';
    return path === p || path.startsWith(`${p}/`);
  });
}

export function isProxyRequiredPath(pathname: string): boolean {
  const path = normalizePath(pathname);
  return PROXY_REQUIRED_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
